import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetPessoaParametroList() {
  const { invocarApi, ...outrasPropriedades } = useApiBase();

  const getPessoaParametroList = useCallback(
    async (pessoaId: string, parametroId: string) => {
      return invocarApi({
        url: `${VariaveisAmbiente.apiVersion}/pessoa/${pessoaId}/parametro?parametroId=${parametroId}`,
        method: 'GET',
        enviarTokenUsuario: true,
      });
    },
    [invocarApi],
  );
  return {
    ...outrasPropriedades,
    getPessoaParametroList,
  };
}
